// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-0d2f496b]{white-space:nowrap}.active-status[data-v-0d2f496b]{content:\"\";position:absolute;bottom:7%;right:-4%;width:30%;height:30%;border-radius:50%;border:2px solid #fff;background-color:#1abc9c}.usr-img-frame[data-v-0d2f496b]{position:relative}.table-header h3[data-v-0d2f496b]{margin-bottom:.6rem;@media (max-width:576px){margin-bottom:1.2rem}}", ""]);
// Exports
module.exports = exports;
